<template>

  <div class="row mx-0">
    <b-card class="col-9">

      <b-row>

        <b-form-input
          v-model="filtersTemp.search"
          placeholder="Buscar por nombre o identificacion del paciente."
          type="text"
          :class="isXima ? 'col-3 mb-1' : 'col-4 mb-1'"
        />

        <v-select 
          id="cobertura" 
          v-model="filtersTemp.tipoCobertura" 
          :options="opsCobertura"
          placeholder="Buscar por cobertura." 
          :reduce="option => option.value" 
          label="text" 
          :class="isXima ? 'col-3' : 'col-4'"
        />

        <v-select
          v-if="isXima"
          id="establecimiento"
          v-model="filtersTemp.establecimiento"
          :options="establecimientos"
          placeholder="Buscar por establecimiento."
          :reduce="option => option.value"
          label="text"
          class="col-3"
        />
        
        <v-select
          id="estado"
          v-model="filtersTemp.estadoImagen"
          :options="estados"
          placeholder="Buscar por estado."
          :reduce="(option) => option.value"
          label="text"
          :class="isXima ? 'col-3' : 'col-4'"
        />

        <v-select
          id="estado"
          v-model="filtersTemp.tipoImagen"
          :options="tipoImagenOpts"
          placeholder="Tipo de imagen"
          :reduce="(option) => option.value"
          label="text"
          class="col-4"
        />


        <b-col class="col-5">
          <b-form-radio-group
            v-model="filtersTemp.tipoFecha"
            :options="optionsFecha"      
            name="radio-inline"
            class="mb-1"
          />

          <b-row v-if="filtersTemp.tipoFecha">
            <b-col>
              <flat-pickr
                v-model="filtersTemp.fechaDesde"
                placeholder="Fecha Programada Desde:"
                class="form-control col-12"
              />
            </b-col>
            <b-col>
              <flat-pickr
                v-model="filtersTemp.fechaHasta"
                placeholder="Fecha Programada Hasta:"
                class="form-control col-12"
              />
            </b-col>
          </b-row>
        </b-col>

        <b-col class="mt-2"> 
          <b-button 
            variant="primary" 
            @click="onSetFilters"
          >
            <font-awesome-icon icon="magnifying-glass" style="color: white" />
            Buscar
          </b-button>

          <b-button 
            class="ml-1" 
            variant="warning" 
            @click="onClearFilters"
            title="Limpiar filtros"
          >
            <i class="fa-solid fa-eraser"/>
          </b-button>
        
        </b-col>
      </b-row>

    </b-card>


    <b-card class="col-3" style="border: 1px solid #c9c9c9">
      <div >
        <h5 class="mb-1">Observaciones: </h5>
        
        <div class="d-flex align-items-center">
          <h4 class="mb-0">Sin MSP:</h4>
          
          <span class="ml-1">{{ observaciones.sinMsp }} (total)</span>

          <b-form-checkbox
            v-model="filtersTemp.observaciones"
            :value="'sinMsp'"
            switch 
            size="md"
            class="ml-2"
          />
        </div>
        
      </div>
    </b-card>
  </div>
  
</template>

<script>
import { getEstablecimientoLS, comprobarRoles } from '@/shared/helpers';
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import { getIdDoctorLS } from '@/shared/helpers/dataLocalStorage';
import { ROLES } from '@/shared/constants';
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { fetchTipoImagenSelect }      from '../services/tipoImagen';



export default {

  name: "FilterImagenes",

  components: {
    vSelect,
    flatPickr
  },

  created() {
    this.loadDataInit();
    this.loadFiltersLS();
    this.getObservaciones();
  },


  data() {
    return {
      currentEstablecimiento: getEstablecimientoLS && getEstablecimientoLS(),

      filtersTemp:{
        search: null,
        establecimiento: null,
        tipoFecha     : "1",
        estadoImagen  : null,
        tipoImagen    : null,
        tipoCobertura : null,
        fechaDesde    : null,
        fechaHasta    : null,
        observaciones : null
      },

      opsCobertura: [
        { text : 'IESS',       value : '1' },
        { text : 'ISSPOL',     value : '2' },
        { text : 'ISSFA',      value : '3' },
        { text : 'MSP',        value : '4' },
        { text : 'PARTICULAR', value : '5' }
      ],

      filters: null,

      observacionSelected:null,
      observaciones:{
        sinMsp: null,
      },

      tipoImagenOpts:[],

      optionsFecha : [
        { value : "1", text : "Fecha programación" }, 
        { value : "2", text : "Fecha atención"     }
      ],

      estados: [
        { value: "Creado",     text: "Creado" },
        { value: "Programada", text: "Programada" },
        { value: "Incompleto", text: "Incompleto" },
        { value: "Terminada",  text: "Terminada" },
      ],
      establecimientos: [],
    }
  },


  methods: {


    async loadDataInit(){
      this.tipoImagenOpts = await fetchTipoImagenSelect();
      if (this.isXima) {
        await this.fetchEstablecimientos();
      }
    },

    loadFiltersLS(){
      const dataFilters = JSON.parse(localStorage.getItem('filterImagenes'));
      if(dataFilters) this.filtersTemp = dataFilters;
      this.onSetFilters();
    },

    onSetFilters(){
      this.filters = { ...this.filtersTemp };
      this.$emit('apply-filters'); // Notificar al componente padre
      this.getObservaciones(); // Actualizar las observaciones con los nuevos filtros
    },

    onClearFilters(){
      this.filtersTemp = {
        search          : null,
        tipoFecha       : null,
        estadoImagen    : null,
        tipoImagen      : null,
        fechaDesde      : null,
        fechaHasta      : null,
        tipoCobertura   : null,
        observaciones   : null,
        establecimiento : null
      };

      this.onSetFilters();
    },

    async getObservaciones() {
      const query = `
        query NumeroObservacionesImagenes(
          $establecimiento    : ID
          $search             : String
          $fechaDesde         : String
          $fechaHasta         : String
          $tipoCobertura      : String 
          $tipoFecha          : String 
          $tipoImagen         : String
          $estadoImagen       : String  
        ) {
          numeroObservacionesImagenes(
            search              : $search
            establecimiento     : $establecimiento
            fechaDesde          : $fechaDesde
            fechaHasta          : $fechaHasta
            estadoImagen        : $estadoImagen
            tipoImagen          : $tipoImagen
            tipoCobertura       : $tipoCobertura
            tipoFecha           : $tipoFecha
          ) {
            status
            sinMsp
          }
        }
      `;

      const establecimiento = getEstablecimientoLS && getEstablecimientoLS();
      let doctor = null;
      if(this.isDoctor) doctor = getIdDoctorLS();

      const variables = {
        establecimiento: this.filters?.establecimiento || (establecimiento && establecimiento.id ? establecimiento.id : null),
        doctor,
        search            : this.filters.search       || '',
        estadoImagen      : this.filters.estadoImagen,
        tipoCobertura     : this.filters.tipoCobertura,
        fechaDesde        : this.filters.fechaDesde   || '',
        fechaHasta        : this.filters.fechaHasta   || '',
        tipoFecha         : this.filters.tipoFecha     || '',
        tipoImagen        : this.filters.tipoImagen     || ''
      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });

        if(response.status !== 200) return;
        
        const response2 = response.data.data.numeroObservacionesImagenes;
        if( response2.status !== 'success' ) return;

        const data = {
          sinMsp: response2.sinMsp 
        };
        
        this.observaciones = data;

      } catch (error) {
        console.log(error)
      }
    },

    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;

      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value    : item.id,
          text     : item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },
  },


  computed:{

    isDoctor(){
      return comprobarRoles( ROLES.DOCTOR );
    },
    isXima(){
      return this.currentEstablecimiento?.uniCodigo === '36451';
    }
  },


  watch: {

    filters: {
      deep: true,
      handler() {
        if(!this.filters) return;
        localStorage.setItem('filterImagenes', JSON.stringify(this.filters));
        this.$store.commit('setFilterImagenes', this.filters);
      },
    },


  
    // 'filtersTemp.observaciones': {
    //   deep: true,
    //   handler() {
    //     this.onSetFilters();
    //   },
    // },
  }
}
</script>
